import React, { useMemo } from 'react'
import { CsvColumnProfile } from '../types/csv.types'

interface Props {
    columns: CsvColumnProfile[]
    rows: Record<string, string>[]
}

const CsvPreview: React.FC<Props> = ({ columns, rows }) => {
    const displayRows = useMemo(() => rows.slice(0, 50), [rows])

    if (columns.length === 0) return null

    return (
        <div className="border border-slate-200 rounded mt-2 max-h-[18rem] overflow-auto">
            <table className="min-w-full text-[0.6rem] border-collapse">
                <thead className="bg-slate-100 sticky top-0 z-10">
                    <tr>
                        {columns.map((col) => (
                            <th key={col.name} className="p-1 text-left border-b border-slate-200 whitespace-nowrap font-semibold" title={col.name}>
                                {col.name}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {displayRows.map((row, rowIndex) => {
                        const rowKey = `${rowIndex}-${columns
                            .slice(0, 3)
                            .map((c) => row[c.name] ?? '')
                            .join('|')}`
                        return (
                            <tr key={rowKey} className="odd:bg-white even:bg-[#E5B61112]">
                                {columns.map((col) => {
                                    const value = row[col.name] ?? ''
                                    return (
                                        <td key={col.name} className="p-1 border-b border-slate-100 whitespace-nowrap max-w-[16rem] overflow-hidden text-ellipsis" title={value}>
                                            {value}
                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                    {displayRows.length === 0 && (
                        <tr>
                            <td colSpan={columns.length} className="p-3 text-center text-slate-500">
                                No preview rows
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default CsvPreview
